export const EventTrackerToken = Symbol('EventTracker');
export const AuthorizerToken = Symbol('Authorizer');
export const AuthenticationToken = Symbol('Authentication');
